import { Component, OnInit } from '@angular/core';
import { HelperService } from '@sb-tools/typescript/services/helper.service';
import { TicketDetailsComponent } from '../ticket-details/ticket-details.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-onetime',
    templateUrl: './onetime.component.html',
    styleUrls: ['./onetime.component.scss'],
    imports: [TicketDetailsComponent, TranslateModule],
})
export class OnetimeComponent implements OnInit {
    isMobileOrTabletDevice = HelperService.isMobileOrTabletDevice;

    ngOnInit() {
        if (this.isMobileOrTabletDevice) {
            document.body.classList.add('mobile');
        }
    }
}
